import React, {useEffect} from "react";
import {useParams, useSearchParams} from "react-router-dom";
import {fetchPaymentHistory} from "../../store/vendor-slice";
import {useDispatch, useSelector} from "react-redux";
import SubHeader from "../../components/header/SubHeader";
import Button from "../../components/common/button/Button";
import Table from "../../components/common/table/Table";
import {getVendorHistoryTableColumns, getVendorHistoryTableData} from "../../models/vendorModel"
import {Role} from "../../enums/enums";

const VendorPaymentHistory = () => {
    const params = useParams();
    const [searchParams] = useSearchParams();
    const dispatch = useDispatch();
    const {pagination} = useSelector(state => state.vendor);
    const userRole = useSelector((state) => state.auth.selectedRole);
    const list = useSelector(state => state.list);
    const {items: vendors} = list.vendor;

    //set initial page and limit
    const initialPage = Number(searchParams.get("page")) || 1;
    const initialLimit = Number(searchParams.get("limit")) || 25;

    useEffect(() => {
        dispatch(fetchPaymentHistory({...userRole, id: params.vendorId, page: initialPage, limit: initialLimit}));
    }, [dispatch, params.vendorId, userRole, initialPage, initialLimit]);

    const getVendorName = (vendors, vendorId) => {
        return vendors[vendorId] || "Unknown Vendor";
    }

    const {
        paymentHistory: items,
        fetchPaymentHistoryStatus,
        error
    } = useSelector(state => state.vendor); // Adjust based on your Redux slice

    const tableColumns = getVendorHistoryTableColumns();
    const tableData = getVendorHistoryTableData({items});

    return (
        <>
            <SubHeader title={`Vendor Payment History - (${getVendorName(vendors, params.vendorId)})`}>
                {userRole.role !== Role.Manager &&
                    <Button to={`/vendor/${params.vendorId}/getDue`} className="btn-sm bg-primary bg-opacity-50">Get
                        Dues</Button>}
                <Button to={`/vendor/${params.vendorId}/purchase`}
                        className="btn-sm bg-primary bg-opacity-50">Purchase</Button>
                {/*<Button to={`../../?page=${currentPage}&limit=${limit}`}*/}
                {/*        className="btn-sm bg-secondary bg-opacity-50">Back</Button>*/}
            </SubHeader>
            <div className="container p-0 ms-0">
                {fetchPaymentHistoryStatus === "loading" && <p>Loading...</p>}
                {fetchPaymentHistoryStatus === "failed" && <h6 className="text-danger">{error}</h6>}
                {fetchPaymentHistoryStatus === "success" && <Table
                    className="mobile-responsive"
                    columns={tableColumns}
                    data={tableData}
                    pagination={pagination}
                />}
            </div>
        </>
    )
}

export default VendorPaymentHistory;